import { render, staticRenderFns } from "./CustomizeTableData.vue?vue&type=template&id=58927ef2&scoped=true"
import script from "./CustomizeTableData.vue?vue&type=script&lang=js"
export * from "./CustomizeTableData.vue?vue&type=script&lang=js"
import style0 from "./CustomizeTableData.vue?vue&type=style&index=0&id=58927ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58927ef2",
  null
  
)

export default component.exports